// extracted by mini-css-extract-plugin
module.exports = {"infoContainer":"info_section_infoContainer__3Xd1M","button":"info_section_button__CFzrv"};